import React from 'react'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ProgramsAvailable.scss"
import { trackEvent } from '../../utils/gaTracking';
import { useSelector } from 'react-redux';

function ProgramsAvailable({ data }) {
  const authState = useSelector((state) => state.authUser);
  const user_id = authState?.profile?.user_id;
  const user_email = authState?.profile?.email;
  
  const settings = {
    dots: false,
    arrows: data.length > 1,
    infinite: data.length > 1,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
  };
  return (
    <div className="programs-slider-container" style={{textAlign: 'center'}}>
      <Slider {...settings}>
        {data.map((item, index) => <div key={index}>
          { item?.redirect_url ? <img src={item?.media_url} alt={item.title} style={{  margin: 'auto', objectFit: 'cover !important', width: '100%', cursor: 'pointer' }} onClick={() => { trackEvent('hrd_programs_available_viewed', 'HRD Programs Available Viewed', 'HRD Programs Available Viewed', 1, user_id, user_email); window.open(`${item?.redirect_url}`, '_blank', 'noopener') }} />
            : <img src={item?.media_url} alt={item.title} style={{  margin: 'auto', objectFit: 'cover !important', width: '98%', borderRadius: '20px' }} className='programSliderImage'/>}
        </div>)}
      </Slider>
    </div>
  );
}

export default ProgramsAvailable
